<template>
    <el-dialog
        title="支付分账费用"
        top="3%"
        width="1200px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'initiatePaymentDialog'"
        >
        <div v-loading="pageLoading">
            <div>
                <span><i class="star">*</i>付款商户号：</span>
                <el-select v-model="selectedAccount" clearable placeholder="请选择">
                    <el-option
                        v-for="item in accountList"
                        :key="item.bankAccount"
                        :label="item.bankAccountName"
                        :value="item.bankAccount">
                    </el-option>
                </el-select>
            </div>
            <div class="table-wrapper">
                <p class="title">支付订单明细：</p>
                <edit-table
                    ref="editTable"
                    :loading="pageLoading"
                    :tableConfig="payOrderDetailConfig"
                    :tableData="tableData"
                    @element-change="elementChange"
                >
                </edit-table>
            </div>
            <!-- <div class="checkbox-wrapper">
                <el-checkbox :value="checked" @click.native.prevent="showClauseDialog">我已阅读并同意支付条款说明</el-checkbox>
            </div> -->
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">发起支付</el-button>
        </div>

        <el-dialog
            title="支付条款说明"
            :visible.sync="clauseDialogVisible"
            width="600px"
            center
            :append-to-body="true"
            :close-on-click-modal="false"
            :custom-class="'clause-dialog'">
            <div style="min-height:200px;">这里是支付条款说明内容...</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agreeClause">我已阅读并同意条款</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
import editTable from './editTable.vue';
import { payOrderDetailConfig } from './config.js';
import * as api from '@/modules/transport/otp/api/driverExpenseSplit.js';
import { mapState } from 'vuex';
import userConfig from '@/config/user.env.js';
export default {
    name: 'SplitPaymentDialog',
    components: { editTable },
    props: {
        componentData: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            payOrderDetailConfig,
            selectedAccount: '',
            accountList: [],
            tableData: [],
            pageLoading: false,
            btnLoading: false,
            checked: true,
            clauseDialogVisible: false
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier
        })
    },
    mounted () {
        this.initPage();
    },
    methods: {
        initPage () {
            this.pageLoading = true;
            Promise.all([this.queryAccountList(), this.queryBatchPayList()])
                .catch(() => {})
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        queryAccountList () {
            api.queryMideaPayAccountList({ carrierCode: this.supplier.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    this.accountList = res.data || [];
                    if (this.accountList.length === 1) {
                        this.selectedAccount = this.accountList[0].bankAccount;
                    }
                }
            }).catch(() => {});
        },
        queryBatchPayList () {
            const dispatchNoList = this.componentData.map(item => item.dispatchNo);
            api.driverBatchPayList({ dispatchNoList, carrierCode: this.supplier.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    if (res.errMsg === 'midea_pay_not_exist') {
                        this.$confirm('您还没开通美的付账号，无法发起支付！', '提示', {
                            confirmButtonText: '去开通',
                            showCancelButton: false,
                            type: 'warning'
                        }).then(() => {
                            this.$emit('refresh', 'initiatePaymentDialogShow');
                            // 跳转到LSRM--工作台--基础信息---银行账户tab页
                            this.$router.push({
                                path: '/lsrm/basicInfo',
                                query: { tabFinance: 1 }
                            });
                        }).catch(() => {});
                    } else {
                        this.tableData = res.data || [];
                        this.tableData.forEach((item, index) => {
                            item.tableIndex = index + 1;
                            item.id = item.driverNo;
                            // 判断当支付对象=直接支付司机时，支付类型默认为【对私支付】，不可更改 当支付对象=第三方网货平台时，支付类型默认为【对公支付】，不可更改
                            item.payeeAcctType = item.payObject === '2' ? '0' : item.payObject === '3' ? '2' : null;
                            item.payeeAcctTypeDisabled = item.payObject === '2' || item.payObject === '3'
                        });
                    }
                }
            }).catch(() => {});
        },
        elementChange ({ prop, val, row, index }) {
            // ${prop}Error 为true，字段单元格做标红处理
            if (prop === 'bankAccount') {
                // 收款卡号（bankAccount） 只能输入大于10位的数字
                row[prop] = row[prop].replace(/[^\d]/g, '');
                this.$set(row, 'bankAccountError', row.bankAccount && row.bankAccount.length < 10);
                // 收款户名（payeeName） 可根据选择的收款卡号带出，也可以手动输入
                this.$set(row, 'payeeName', Object.keys(val).length && val.bankAccountName ? val.bankAccountName : row.payeeName);
                this.$set(row, 'payeeNameError', +row.payObject === 2 && row.payeeName && row.payeeName !== row.driver);
            } else if (prop === 'payeeName') {
                // 收款户名（payeeName） 支付对象为直接支付司机（payObject=2）时，收款户名和司机名称需保持一致。当前仅提示，不阻断
                this.$set(row, 'payeeNameError', +row.payObject === 2 && row.payeeName && row.payeeName !== row.driver);
            } else if (['payeeAcctType', 'bankname'].includes(prop)) {
                // 开户行（bankname） 支付类型（payeeAcctType）为对公支付时，开户行必填
                this.$set(row, 'banknameError', +row.payeeAcctType === 2 && !row.bankname);
            }
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:initiatePaymentDialogShow', false);
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            if (!this.selectedAccount) {
                return this.$message.warning('请选择付款商户号');
            }
            if (!this.$refs.editTable.saveData()) return;
            if (this.tableData.some(item => item.bankAccount.length < 10)) {
                return this.$message.warning('收款卡号不少于10位数字,请重新输入');
            }
            if (this.tableData.some(item => +item.payeeAcctType === 2 && !item.bankname)) {
                return this.$message.warning('支付类型为对公支付时,开户行必填');
            }
            if (!this.checked) {
                return this.$message.warning('请阅读并同意支付条款说明');
            }
            this.btnLoading = true;
            const params = {
                payerPartner: this.selectedAccount,
                carrierCode: this.supplier.supplierCode,
                carrierName: this.supplier.supplierName,
                subPayList: this.tableData.map(({ driver, driverNo, driverContactWay, dispatchCount, payObject, payAmount, payeeName,
                    bankAccount, bankname, banknumber, province, city, payeeAcctType, dispatchNoList }) => ({
                    driver,
                    driverNo,
                    driverContactWay,
                    dispatchCount,
                    payObject,
                    payAmount,
                    payeeName,
                    payeeBankAcctNo: bankAccount,
                    payeeAcctType,
                    payeeBankName: bankname,
                    payeeBankCode: banknumber,
                    payeeAcctProvince: province,
                    payeeAcctCity: city,
                    dispatchNoList
                }))
            };
            api.batchPay(params).then(res => {
                if (res && +res.code === 0) {
                    if (+res.data.payResult === 1) {
                        this.paySuccessMsg(res.data);
                    } else {
                        this.payFailedMsg(res.data.errorRecords);
                    }
                }
            })
                .catch(() => {})
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        paySuccessMsg(data) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('div', {style: 'text-align: center;'}, [
                    h('div', { style: 'font-size: 16px; font-weight: bold; margin-bottom: 14px' }, '发 起 成 功 !'),
                    h('div', { style: 'line-height: 2; font-size: 14px' }, [
                        h('span', null, '支付批次号：'),
                        h('span', { style: 'margin-right: 8px;' }, data.batchNo),
                        h('a', {
                            style: 'color: #00bcd4; cursor: pointer; font-size: 14px;',
                            on: {
                                click: () => {
                                    this.copyToClip(data.batchNo.split('_')[1]);
                                }
                            }
                        }, '复制批次号')
                    ]),
                    h('div', { style: 'font-size: 14px; margin-bottom: 14px' }, [
                        h('span', null, '付款商户号：'),
                        h('span', null, data.payerPartner)
                    ])
                ]),
                showConfirmButton: true,
                confirmButtonText: '去支付',
                customClass: 'pay-success-message',
                beforeClose: (action, instance, done) => {
                    this.$emit('refresh', 'initiatePaymentDialogShow');
                    if (action === 'confirm') {
                        const url = userConfig.env === 'PROD' ? 'https://mch.mideaepay.com/' : 'https://mch.mideaepayuat.com/';
                        window.open(url);
                    }
                    done();
                }
            });
        },
        payFailedMsg(data) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('div', null, [
                    h('div', { style: 'text-align: center; font-size: 16px; font-weight: bold; margin-bottom: 14px' }, '发 起 失 败 !'),
                    ...(data && data.length > 0 ? [
                        h('div', {style: 'font-size: 14px;'}, '失败原因：'),
                        ...data.map((item, index) => {
                            return h('div', { style: 'margin-bottom: 14px; display: inline-block; width: 100%; max-height: 400px; overflow:auto; font-size: 14px; line-height: 2;' }, [
                                h('div', null, [
                                    h('span', null, (index + 1) + '. '),
                                    h('span', null, item.tradeNo ? item.tradeNo + ',' : ''),
                                    h('span', null, item.errorDescription)
                                ])
                            ]);
                        }).filter(Boolean)
                    ] : [])
                ]),
                showConfirmButton: true,
                confirmButtonText: '确定',
                customClass: 'pay-failed-message',
                beforeClose: (action, instance, done) => {
                    this.$emit('refresh', 'initiatePaymentDialogShow');
                    done();
                }
            });
        },
        copyToClip (txt) {
            // 检查是否支持 Clipboard API
            if (navigator.clipboard) {
                navigator.clipboard.writeText(txt).then(() => {
                    this.$message.success(`‘${txt}’复制成功`);
                }).catch(err => {
                    this.$message.error('复制失败:', err);
                });
            } else {
                // 备选方案：如果 Clipboard API 不可用
                var input = document.createElement('input');
                input.setAttribute('value', txt);
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$message.success(`‘${txt}’复制成功`);
            }
        },
        showClauseDialog () {
            if (this.checked) {
                this.checked = !this.checked;
            } else {
                this.clauseDialogVisible = true;
            }
        },
        agreeClause() {
            this.checked = true;
            this.clauseDialogVisible = false;
        }
    }
};
</script>

<style lang="less">
.initiatePaymentDialog{
    .el-dialog__body {
        padding: 16px 24px;
        font-size: 13px;
    }
    .star {
        color: red;
        margin-right: 4px;
    }
    .table-wrapper {
        margin-left: 4px;
    }
    .checkbox-wrapper {
        margin-top: 16px;
        .el-checkbox__label {
            display: inline-block;
            vertical-align: middle;
            font-size: 13px;
        }
    }
}
.pay-failed-message, .pay-success-message {
    .el-message-box__btns {
        text-align: center !important;
    }
}
</style>
